import React, { useRef } from 'react'
import { Modal, Icon } from 'antd'
import { isEmptyOrNull } from '../helpers'

export const ModalBox = ({
  content,
  title,
  visible,
  submitHandler,
  cancelHandler,
  submitText,
  top,
  cancelText,
  submitDisabled,
  cancelDisabled,
  closable = true,
  size,
  titleIcon = 'user'
}) => {

  const formId = useRef(`modal-form-${Math.random().toString(36).slice(2)}`)

  const buttonStyles = {
    minWidth: '100px',
    height: '35px',
    borderRadius: '30px'
  }

  const maskStyle = {
    backdropFilter: 'blur(3px)'
  }

  const handleSubmit = event => {
    if(event && event.preventDefault){
      event.preventDefault()
    }

    if(!submitDisabled && submitHandler){
      submitHandler(event)
    }
  }

  return (
    <Modal
      title={<><Icon type={titleIcon} /> {title}</>}
      visible={visible}
      closable={closable}
      maskStyle={maskStyle}
      onOk={handleSubmit}
      width={size}
      style={{ top: isEmptyOrNull(top) ? '' : `${top}px` }}
      okButtonProps={{ className: 'success-btn', disabled: submitDisabled, style: buttonStyles, htmlType: 'submit', form: formId.current }}
      cancelButtonProps={{ type: 'danger', disabled: cancelDisabled, style: buttonStyles }}
      onCancel={cancelHandler}
      okText={submitText}
      cancelText={cancelText}
    >
      <form id={formId.current} onSubmit={handleSubmit}>
        {content}
      </form>
    </Modal>
  )
}
